import classNames from 'classnames';

import { ButtonColor, ButtonStyleProps, ButtonVariant } from './types';

import style from './button.module.css';

const defaultButtonColor: ButtonColor = 'turquoise';
const defaultVariant: ButtonVariant = 'filled';

const buttonColorMap: Record<ButtonColor, string> = {
  black: style.buttonColorBlack,
  orange: style.buttonColorOrange,
  turquoise: style.buttonColorTurquoise,
  white: style.buttonColorWhite,
};

const buttonVariantMap: Record<ButtonVariant, string> = {
  filled: style.buttonVariantFilled,
  outlined: style.buttonVariantOutlined,
};

export const getButtonClassName = ({
  buttonColor = defaultButtonColor,
  variant = defaultVariant,
}: ButtonStyleProps): string => {
  return classNames(
    style.button,
    buttonColorMap[buttonColor],
    buttonVariantMap[variant],
  );
};
